import styled from "styled-components";
import colors from "../../styles/colors";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 30px 0 80px 0;

    & img {
        object-position: top;
    }
`;

const AllMatchesContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 90%;
    gap: 30px;
`;

type WinState = 'win' | 'loss' | 'nc';

const WinBadge = styled.span<{ result: WinState }>`
    position: absolute;
    top: 6px;
    right: 10px;
    font-size: 11px;
    font-weight: bold;
    padding: 2px 7px;
    border-radius: 4px;
    z-index: 2;
    letter-spacing: 0.5px;
    background-color: ${props =>
        props.result === 'win' ? 'rgba(40, 167, 69, 0.9)' :
        props.result === 'nc'  ? 'rgba(255, 193, 7, 0.9)'  :
                                 'rgba(220, 53, 69, 0.9)'
    };
    color: white;
`;

const SingleCardMatchContainer = styled.div<{ winState: WinState }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(25% - 30px);
    padding: 40px 10px 10px 10px;
    border: 1px solid ${props =>
        props.winState === 'win'  ? 'rgba(40, 167, 69, 0.5)'  :
        props.winState === 'loss' ? 'rgba(220, 53, 69, 0.5)'  :
        props.winState === 'nc'   ? 'rgba(255, 193, 7, 0.5)'  :
        'rgba(163, 27, 27, 0.35)'
    };
    border-radius: 10px;
    background: linear-gradient(160deg, rgba(163, 27, 27, 0.28) 0%, rgba(255, 255, 255, 0.07) 100%);
    color: rgba(255, 255, 255, 0.85);
    min-height: 380px;
    cursor: pointer;
    transition: all 0.22s ease;

    &:hover {
        transform: translateY(-4px);
        border-color: rgba(163, 27, 27, 0.65);
        box-shadow: 0 8px 28px rgba(163, 27, 27, 0.15), 0 4px 12px rgba(0, 0, 0, 0.4);
        color: white;
    }

    & .box-top-title-avatar-ppv {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;

        & img {
            width: 20px;
            object-fit: cover;
        }
    }

    & .hover-content {
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        padding: 10px;

        & img {
            width: 150px;
            height: 180px;
            object-fit: contain;
            margin-bottom: 10px;
        }

        & .hover-text-container {
            text-align: center;

            & .hover-ppv-name {
                font-weight: bold;
                font-size: 16px;
                margin-bottom: 5px;
                color: #666;
            }

            & .hover-ppv-year {
                font-size: 14px;
                color: #666;
            }
        }
    }

    &:hover .hover-content {
        display: flex;
    }

    &:hover .normal-content {
        display: none;
    }
`;

const ContainerPpvAvversarioMatch = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    & img {
        width: 100px;
        height: 100px;
        object-fit: cover;
    }

    & .box-avversario {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        margin: 2px solid bla;

        & img {
            width: 160px;
            height: 160px;
            object-fit: cover;
        }
    }

    & .box-wrestlers {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    & .box-name-wrestlers {
        text-align: center;

        & .name-wrestler {
            font-size: 12px;
            text-transform: uppercase;
            font-weight: 700;
        }
    }

    &.single img {
        width: 150px;
        max-width: 45%;
        height: 150px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.triple img {
        width: 100px;
        max-width: 30%;
        height: 100px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.fatal img {
        width: 75px;
        max-width: 22%;
        height: 75px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.tag img {
        width: 75px;
        max-width: 22%;
        height: 75px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.generic img {
        width: 150px;
        max-width: 80%;
        height: 150px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }
`;

const BoxLastMatchInfoPpv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    & .name-ppv {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 16px;
        /* background-color: ${colors.bgColorBlack2}; */
        padding: 10px 65px;


        & span {
            margin: 0 !important;
            padding: 0 !important;
            font-weight: 700;
            font-size: 18px;
        }
    }
`;

const BoxLastMatchType = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    & .box-wrestlers {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    & .box-name-wrestlers {
        text-align: center;

        & .name-wrestler {
            font-size: 18px;
            text-transform: uppercase;
            font-weight: 700;
        }
    }

    &.single img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.triple img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.fatal img {
        width: 75px;
        height: 75px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.tag img {
        width: 75px;
        height: 75px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    &.generic img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        margin-left: 3px;
        margin-right: 3px;
    }

    & .name-match-generic {
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 700;
        margin-top: 3px;
    }
`;

const TopDecorColor = styled.div<{ winState: WinState }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 30px;
    background-color: ${props =>
        props.winState === 'win'  ? 'rgba(40, 167, 69, 0.75)'  :
        props.winState === 'loss' ? 'rgba(220, 53, 69, 0.75)'  :
        props.winState === 'nc'   ? 'rgba(255, 193, 7, 0.75)'  :
        colors.bgColorBlack2
    };
`;

const BeltContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    & img {
        width: 25px;
        height: 25px;
        object-fit: cover;
    }

`;

function WrestlerAllMatches({ wrestlerData }: any) {

    const navigate = useNavigate();

    const navigateToPpv = (ppv: any) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }

    const renderMatchType = (match: any) => {
        const { type_match, wrestlers } = match;
        
        switch (type_match.type) {
            case 'single':
                return (
                    <BoxLastMatchType className="single">
                        <div className="box-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <img key={key} src={process.env.REACT_APP_STORAGE_URL + wrestlerMatch.avatar_path} alt={wrestlerMatch.avatar_path + "_alt"} />
                            ))}
                        </div>
                        <div className="box-name-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <div className="name-wrestler-container" key={key}>
                                    <span className="name-wrestler">{wrestlerMatch.name}</span>
                                    {key === wrestlers.length - 1 ? 
                                        <span></span> : <span className="color-gray"> VS </span>
                                    }
                                </div>
                            ))}
                        </div>
                    </BoxLastMatchType>
                );
            
            case 'triple':
                return (
                    <BoxLastMatchType className="triple">
                        <div className="box-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <img key={key} src={process.env.REACT_APP_STORAGE_URL + wrestlerMatch.avatar_path} alt={wrestlerMatch.avatar_path + "_alt"} />
                            ))}
                        </div>
                        <div className="box-name-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <div className="name-wrestler-container" key={key}>
                                    <span className="name-wrestler">{wrestlerMatch.name}</span>
                                    {key === wrestlers.length - 1 ? 
                                        <span></span> : <span className="color-gray"> VS </span>
                                    }
                                </div>
                            ))}
                        </div>
                    </BoxLastMatchType>
                );
            
            case 'fatal':
                return (
                    <BoxLastMatchType className="fatal">
                        <div className="box-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <img key={key} src={process.env.REACT_APP_STORAGE_URL + wrestlerMatch.avatar_path} alt={wrestlerMatch.avatar_path + "_alt"} />
                            ))}
                        </div>
                        <div className="box-name-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <div className="name-wrestler-container" key={key}>
                                    <span className="name-wrestler">{wrestlerMatch.name}</span>
                                    {key === wrestlers.length - 1 ? 
                                        <span></span> : <span className="color-gray"> VS </span>
                                    }
                                </div>
                            ))}
                        </div>
                    </BoxLastMatchType>
                );
            
            case 'tag':
                return (
                    <BoxLastMatchType className="tag">
                        <div className="box-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <img key={key} src={process.env.REACT_APP_STORAGE_URL + wrestlerMatch.avatar_path} alt={wrestlerMatch.avatar_path + "_alt"} />
                            ))}
                        </div>
                        <div className="box-name-wrestlers">
                            {wrestlers.map((wrestlerMatch: any, key: any) => (
                                <div className="name-wrestler-container" key={key}>
                                    <span className="name-wrestler">{wrestlerMatch.name}</span>
                                    {key !== 1? 
                                        <span> </span> : <span className="color-gray"> VS </span>
                                    }
                                </div>
                            ))}
                        </div>
                    </BoxLastMatchType>
                );
            
            default:
                return (
                    <BoxLastMatchType className="generic">
                        <img 
                            src={process.env.REACT_APP_STORAGE_URL + wrestlerData.avatar_path}
                            alt={wrestlerData.avatar_path + "_alt"}    
                        />
                        <h1 className="name-match-generic">{type_match.name}</h1>
                    </BoxLastMatchType>
                );
        }
    };

    const getWinState = (match: any): WinState => {
        if (match.is_no_contest) return 'nc';
        const me = match.wrestlers?.find((w: any) => w.id === wrestlerData.id);
        if (!me) return 'nc';
        return me.is_winner ? 'win' : 'loss';
    };

    const winLabel = (match: any): string => {
        if (match.is_no_contest) return 'NC';
        const me = match.wrestlers?.find((w: any) => w.id === wrestlerData.id);
        if (!me) return 'NC';
        return me.is_winner ? 'W' : 'L';
    };

    return (
        <Container>
            <h1>Tutti i match del wrestler</h1>
            <AllMatchesContainer className="all-matches-container">
                {wrestlerData.allFights.map((match: any) => (
                    <SingleCardMatchContainer
                     winState={getWinState(match)}
                     className="single-card-match-container"
                     onClick={() => navigateToPpv(match.ppv)}
                     key={match.id}
                    >
                        <WinBadge result={getWinState(match)}>{winLabel(match)}</WinBadge>
                        {/* Contenuto normale */}
                        <div className="normal-content">
                            <TopDecorColor winState={getWinState(match)} className="top-decor-color" />
                            {/* <div className="box-top-title-avatar-ppv">
                            </div> */}

                            <ContainerPpvAvversarioMatch className="container-ppv-avversario-match my-2">
                                {renderMatchType(match)}
                            </ContainerPpvAvversarioMatch>

                            {/* Cintura se presente */}
                            {match.belt && (
                                <BeltContainer className="belt-container">
                                    <img src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.img_path + "_alt"} />
                                    <span>{match.belt.name}</span>
                                </BeltContainer>
                            )}

                            <BoxLastMatchInfoPpv>
                                <div className="name-ppv">
                                    <span>{match.ppv.ppv_description.name}</span>
                                    {/* La data è in formato "25-05-2025, prendo solo l anno  */}
                                    <span>{match.ppv.date.split('-')[2]}</span>
                                </div>
                            </BoxLastMatchInfoPpv>
                        </div>

                        {/* Contenuto hover */}
                        <div className="hover-content">
                            <img 
                                src={process.env.REACT_APP_STORAGE_URL + match.ppv.img_path} 
                                alt={match.ppv.img_path + "_alt"}
                            />
                            <div className="hover-text-container">
                                <div className="hover-ppv-name">
                                    {match.ppv.ppv_description.name}
                                </div>
                                <div className="hover-ppv-year">
                                    {match.ppv.date.split('-')[2]}
                                </div>
                            </div>
                        </div>
                    </SingleCardMatchContainer>
                ))}
            </AllMatchesContainer>
        </Container>
    )
}

export default WrestlerAllMatches;